export default "/images/6e9b4b949f30b948dabdeaa534f92192.jpg";